<template>
  <div class="media">
    <div class="icon-main icon-main-mobile">
      <div class="icon-round">
        <svg class="outlets">
          <use class="fill-white" xlink:href="#store" />
        </svg>
      </div>
    </div>
    <div class="media-body">
      <div class="timeline-card">
        <h4 class="title">{{ _T('Select Store') }}</h4>
        <div class="right-content-details">
          <ul>
              <li v-for="(store, key) in availableStores" :key="key">
              <label
                class="store-entity"
                :class="{ active: store._id == selectedStore }"
              >
                <div class="location-box">
                  <div>
                    <svg class="outlets">
                      <use class="fill-white" xlink:href="#store" />
                    </svg>
                  </div>
                </div>
                <div class="address">
                  <div class="store-address">
                    <p>
                      <strong>{{ store.name }} </strong>
                    </p>
                    <p>{{ store.address }}, {{ store.city }}</p>
                  </div>
                  <input
                    type="radio"
                    name="selectedStore"
                    :value="store._id"
                    v-model="selectedStore"
                  />
                </div>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <loader v-show="processInProgress(process)" />
  </div>
</template>
<script>
import Loader from '@/components/Elements/Loader.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      process: 'load-selected-store',
    }
  },
  components: {
    Loader,
  },
  computed: {
    ...mapActions(['revalidateCartItems']),
    ...mapGetters([
      '_T',
      'currentStore',
      'availableStores',
      'selectedCheckoutStore',
      'processInProgress',
    ]),
    selectedStore: {
      get() {
        //this ll return availableStores[0] at first time if there is not getters.selectedCheckoutStore
        return this.currentStore._id
      },
      set(val) {
        //find_store_by_main_id returns in brand stores if brandwebiste otherwise root stores in goorder
        this.$store.commit(
          'SET_SELECTED_CHECKOUT_STORE',
          this.$store.getters.find_store_by_main_id(val)
        )
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.store-entity {
  width: 100%;
  cursor: pointer;
  display: flex;
  position: relative;
  border: 2px solid var(--color-light-border);
  border-radius: 0.3rem; 
  margin-top:-1px;

  &:after {
    content: '';
    position: absolute;
    background-image: url(/images/svg/global/true-w.svg);
    width: 18px;
    height: 18px;
    right: 0;
    top: 0;
    background-color: var(--color-primary);
    background-repeat: no-repeat;
    background-position: 50%;
    border-radius: 0 4px 0 4px;
    transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75),
      -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
    opacity: 0;
    -webkit-transform: rotate(-45deg) scale(0);
    transform: rotate(-45deg) scale(0);
  }

  &.active {
    border-color: var(--color-primary);
  }
  &.active:after {
    width: 18px;
    height: 18px;
    right: -1px;
    top: -1px;
    opacity: 1;
    background-image: url(/images/svg/global/true-w.svg);
    transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75),
      -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
    -webkit-transform: rotate(0) scale(1);
    transform: rotate(0) scale(1);
  }
}
.address {
  margin-left: 1.5rem;
  border-bottom: 0.0625rem solid var(--color-light-border);
  width: 75%;
  padding-right: 2rem;
  position: relative;

  input[type='radio'] {
    display: none;
  }
}
.store-address {
  p {
    margin: 0;
    padding: 0;
    line-height: 1.3rem;
  }
}
.body-rtl {
  .right-content-details {
    ul {
      padding-right: unset;
      padding-left: 0;
      li {
        .middle-content {
          margin-left: unset;
          margin-right: 1.5rem;
          padding-right: unset;
          padding-left: 2rem;
          p {
            text-align: right;
          }
          .choose-btn {
            right: unset;
            left: 0.625rem;
            svg {
              margin-left: unset;
              margin-right: 0.5rem;
            }
          }
        }
      }
    }
  }
}
.outlets {
  height: $px30;
  width: $px30;
}
.mapPinW {
  height: $px14;
  width: $px14;
}

.right-content-details {
  ul {
    overflow: hidden;
    max-height: $px230;
    overflow-y: auto;
    padding-right: $px10;
    // &::-webkit-scrollbar {
    //   display: none;
    // }
    &::-webkit-scrollbar {
      width: $px6;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: $scrollbar-track;
      border-radius: $px6;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb;
      border-radius: $px4;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: darken($scrollbar-track, 0.2);
    }
    li {
      display: flex;
      cursor: pointer;
      padding-top: 0;
      .location-box {
        width: $px76;
        height: $px85;
        background-color: $color-primary;
        box-shadow: 0px $px4 $px14 rgba($black, 0.07);
        border-radius: $px4;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        .location-detail {
          display: flex;
          align-items: center;
          margin-top: $px12;
          img,
          svg {
            margin-right: $px6;
          }
          span {
            font-size: $px12;
            line-height: $px15;
            color: $white;
          }
        }
      }
      .middle-content {
        margin-left: $px24;
        border-bottom: $px1 solid $light-border;
        width: 75%;
        padding-right: $px32;
        position: relative;
        .choose-btn {
          width: $px35;
          height: $px80;
          border-radius: $px4;
          background-color: rgba(var(--color-primary-source), 0.1);
          display: flex;
          align-items: center;
          text-align: center;
          position: absolute;
          right: $px10;
          top: 0;
          svg {
            margin-left: $px8;
            path {
              fill: $color-primary;
            }
          }
        }
        p {
          text-transform: capitalize;
          line-height: $px22;
          padding-top: $px2;
          padding-bottom: $px2;
          margin: 0;
          max-width: 90%;
        }
      }
      &:last-child {
        .middle-content {
          border-bottom: 0;
        }
      }
    }
  }
}

use {
  &.default-color {
    fill: var(--color-warning-color-source);
  }
}
@media (max-width: 1199px) {
  .right-content-details {
    ul {
      li {
        .middle-content {
          width: 100%;
          .choose-btn {
            right: $px2;
          }
        }
        .location-box {
          width: $px100;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .right-content-details {
    .store-address {
      p {
        margin: 0;
        padding: 0;
      }
    }
    ul {
      li {
        padding-top: $px10;
        margin-left: $px14;
        margin-right: $px14;
        .middle-content {
          padding-right: 0;
          max-width: 66%;
          p {
            line-height: $px17;
            font-size: $px10;
          }
          .choose-btn {
            display: none;
          }
        }
      }
    }
  }
}
</style>
